export default class ItemsTotal {

  deviceCartTotal: number;
  otherCartTotal: number;
  tariffPackageCartTotal: number;

  constructor(deviceCartTotal: number, otherCartTotal: number, tariffPackageCartTotal: number) {
    this.deviceCartTotal = deviceCartTotal;
    this.otherCartTotal = otherCartTotal;
    this.tariffPackageCartTotal = tariffPackageCartTotal;
  }

}
